import * as React from "react";

import { CaseType } from "@teamprevent/common/model";

import { ThunkDispatch } from "redux-thunk";

import { connect, useSelector } from "react-redux";

import { Button } from "semantic-ui-react";

import { OhCase } from "../model";
import { markOhCaseImmunisationClear } from "../../../immunisationOhCase/actions";
import { ApplicationState } from "../../../applicationState";
import { routeIdSelector as customerIdSelector } from "../../customer/selectors";
import { ohCaseSelector } from "../selectors";

import { EppDecision, Covid19VaccinationStatus } from "../../../immunisations/model";
import { ImmunisationClearModal } from "../../../immunisations/components/ImmunisationClearModal";

interface StateProps {
    customerId: string;
    ohCase: OhCase;
}

interface DispatchProps {
    markOhCaseImmunisationClear: (
        customerId: string,
        employeeRecordId: string,
        ohCaseId: string,
        eppDecision: EppDecision,
        internalNotes: string,
        notes: string,
        covid19VaccinationStatus: Covid19VaccinationStatus,
        bookedDateOfFirstVaccination: moment.Moment,
        dateOfFirstVaccination: moment.Moment,
        dateOfSecondVaccination: moment.Moment) => Promise<void>;
}

interface Props {
    ohCase: OhCase;
    markOhCaseImmunisationClear: (
        eppDecision: EppDecision,
        internalNotes: string,
        notes: string,
        covid19VaccinationStatus: Covid19VaccinationStatus,
        bookedDateOfFirstVaccination: moment.Moment,
        dateOfFirstVaccination: moment.Moment,
        dateOfSecondVaccination: moment.Moment) => Promise<void>;
}

const ImmunisationClearBannerUnconnected: React.FunctionComponent<Props> = (props) => {

    const [showModal, setShowModal] = React.useState(false);

    const closeModal = () => setShowModal(false);

    const openModal = () => setShowModal(true);

    const linkedPpqCase = props.ohCase?.linkedOhCases?.find(l => l.caseType === CaseType.PPQ);

    // don't show banner on a route used for pdf generation
    const isPdfRoute = useSelector(
        (state: ApplicationState) => state.router.routes[(state.router as any).route]
            .isPdfRoute ?? false);

    if (props.ohCase?.caseType !== CaseType.IMMUNISATION || !linkedPpqCase || isPdfRoute) {
        return null;
    }

    if (linkedPpqCase.immsClear) {
        return (
            <div className="immunisation-clear-banner">
                Case has been marked as imms clear.
            </div>
        );
    }

    return (
        <div className="immunisation-clear-banner">
            Is the employee now imms clear?
            <Button size="mini" content="Immunisation Clear" onClick={openModal} />
            {showModal && <ImmunisationClearModal
                onClose={closeModal}
                onSubmit={props.markOhCaseImmunisationClear}
                evidenceOfCovid19VaccinationStatusMandatory={linkedPpqCase?.evidenceOfCovid19VaccinationStatusMandatory}
                covidVaccinationEvidenceSharingConsentOnPpq={linkedPpqCase?.covidVaccinationEvidenceSharingConsentOnPpq}
                covidVaccinationEvidenceSharingConsentOnImmunisationReview={linkedPpqCase?.covidVaccinationEvidenceSharingConsentOnImmunisationReview}
            />}
        </div>
    );
};

const mapStateToProps = (state: ApplicationState): StateProps => ({
    customerId: customerIdSelector(state),
    ohCase: ohCaseSelector(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<ApplicationState, undefined, any>): DispatchProps => ({
    markOhCaseImmunisationClear: async (
        customerId: string,
        employeeRecordId: string,
        ohCaseId: string,
        eppDecision: EppDecision,
        internalNotes: string,
        notes: string,
        covid19VaccinationStatus: Covid19VaccinationStatus,
        bookedDateOfFirstVaccination: moment.Moment,
        dateOfFirstVaccination: moment.Moment,
        dateOfSecondVaccination: moment.Moment) => {
        await dispatch(markOhCaseImmunisationClear(
            customerId,
            employeeRecordId,
            ohCaseId,
            eppDecision,
            internalNotes,
            notes,
            covid19VaccinationStatus,
            bookedDateOfFirstVaccination,
            dateOfFirstVaccination,
            dateOfSecondVaccination));
    }
});

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps): Props => ({
    ...stateProps,
    markOhCaseImmunisationClear: (
        eppDecision: EppDecision,
        internalNotes: string,
        notes: string,
        covid19VaccinationStatus: Covid19VaccinationStatus,
        bookedDateOfFirstVaccination: moment.Moment,
        dateOfFirstVaccination: moment.Moment,
        dateOfSecondVaccination: moment.Moment) =>
        dispatchProps.markOhCaseImmunisationClear(
            stateProps.customerId,
            stateProps.ohCase.employeeRecordId,
            stateProps.ohCase.id,
            eppDecision,
            internalNotes,
            notes,
            covid19VaccinationStatus,
            bookedDateOfFirstVaccination,
            dateOfFirstVaccination,
            dateOfSecondVaccination)
});

export const ImmunisationClearBanner = connect(mapStateToProps, mapDispatchToProps, mergeProps)(ImmunisationClearBannerUnconnected);
